import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Calendar, ArrowRight } from 'lucide-react';

const PressPage = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const releases = [
    { date: 'Aug 18, 2025', title: 'New PM Surya Ghar Subsidy Integration Launched on SolarSavers', link: '#' },
    { date: 'Jan 10, 2025', title: 'SolarSavers Platform Officially Launches in India', link: '#' },
  ];

  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-grow pt-24 bg-background">
        <div className="container-solar py-12 md:py-20">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-16"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-foreground">
              Press & <span className="solar-text-gradient">Media</span>
            </h1>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Get the latest news, updates, and media resources about SolarSavers and our mission to modernize the solar industry.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 max-w-6xl mx-auto">
            <div className="lg:col-span-2">
              <h2 className="text-2xl font-bold mb-6 border-b border-border pb-4">Latest Press Releases</h2>
              <div className="space-y-6">
                {releases.map((release, i) => (
                  <motion.article
                    key={i}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: i * 0.1 }}
                    className="group"
                  >
                    <div className="flex items-center gap-2 text-sm text-primary font-medium mb-2">
                      <Calendar className="w-4 h-4" /> {release.date}
                    </div>
                    <a href={release.link} className="inline-block">
                      <h3 className="text-xl font-bold text-foreground group-hover:text-primary transition-colors leading-tight mb-3">
                        {release.title}
                      </h3>
                    </a>
                    <p className="text-muted-foreground">
                      SolarSavers announces major updates and strategic moves to bolster its position as the leading marketplace for solar energy solutions. Read the full release for details.
                    </p>
                    <a href={release.link} className="inline-flex items-center gap-2 text-sm font-bold mt-4 text-foreground group-hover:text-primary transition-colors">
                      Read full story <ArrowRight className="w-4 h-4" />
                    </a>
                  </motion.article>
                ))}
              </div>
            </div>

            <div className="space-y-8">
              <div className="bg-card p-6 rounded-2xl border border-border shadow-sm">
                <h3 className="font-bold text-lg mb-4 flex items-center gap-2">
                  <FileText className="text-primary w-5 h-5" /> Media Contacts
                </h3>
                <p className="text-muted-foreground text-sm mb-4">
                  For press inquiries, interview requests, or high-resolution media assets, please contact our PR team.
                </p>
                <a href="mailto:press@solarsavers.com" className="text-primary font-medium hover:underline block">
                  press@solarsavers.com
                </a>
              </div>

              <div className="bg-secondary/30 p-6 rounded-2xl border border-border">
                <h3 className="font-bold text-lg mb-4">Brand Resources</h3>
                <p className="text-muted-foreground text-sm mb-4">
                  Download our official logos, color palettes, and brand usage guidelines for media use.
                </p>
                <button className="btn-secondary w-full">Download Media Kit (.zip)</button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PressPage;
